import { defineComponent as st, computed as Q, unref as Lt, renderSlot as Oe, normalizeProps as De, mergeProps as Be, createElementVNode as Fe, normalizeClass as Me, toDisplayString as _t, openBlock as z, createElementBlock as K, normalizeStyle as hr, Fragment as me, renderList as we, createBlock as Ee, resolveDynamicComponent as Gt, useSlots as kn, ref as Le, getCurrentInstance as Cn, watch as _e, onMounted as In, onUpdated as Ln, onBeforeUnmount as _n, withCtx as Tt, guardReactiveProps as xt, createCommentVNode as kt, createVNode as On } from "vue";
var _ = /* @__PURE__ */ ((e) => (e.play = "play", e.playing = "playing", e.paused = "paused", e.hovered = "hovered", e.focused = "focused", e.update = "update", e.leave = "leave", e.blur = "blur", e))(_ || {}), vr = /* @__PURE__ */ ((e) => (e.ondemand = "ondemand", e.progressive = "progressive", e))(vr || {}), le = /* @__PURE__ */ ((e) => (e.left = "left", e.right = "right", e.up = "up", e.down = "down", e.vertical = "vertical", e))(le || {}), U = /* @__PURE__ */ ((e) => (e.next = "next", e.previous = "previous", e))(U || {});
const Ot = (e) => e.flatMap(
  (n) => En(n) ? [n] : Array.isArray(n.children) && n.children.length > 0 ? Ot(n.children) : []
);
function En(e) {
  return !e.type.toString().startsWith("Symbol");
}
const Mn = (e, n, r) => {
  var i;
  return (i = e.target) != null && i.tagName.match("TEXTAREA|INPUT|SELECT") || !n ? "" : e.key === "ArrowLeft" ? r ? U.next : U.previous : e.key === "ArrowRight" ? r ? U.previous : U.next : "";
}, An = (e, n) => {
  let r, i, a, s, d;
  const {
    groupsToScroll: g,
    groupsToShow: C,
    slideGroupCount: v,
    currentSlideGroupIndex: y,
    lazyLoad: h,
    infinite: w
  } = e;
  if (s = v % g !== 0, r = s ? 0 : (v - y) % g, n.message === U.previous)
    a = r === 0 ? g : C - r, d = y - a, h && !w && (i = y - a, d = i === -1 ? v - 1 : i);
  else if (n.message === U.next)
    a = r === 0 ? g : r, d = y + a, h && !w && (d = (y + g) % v + r);
  else if (n.message === "dots") {
    if (d = (n.index || 0) * g, d === y)
      return null;
  } else if (n.message === "children") {
    if (d = n.index || 0, d === y)
      return null;
    if (w) {
      let b = $n({ ...e, targetSlideGroupIndex: d });
      d > y && b === "left" ? d = d - v : d < y && b === "right" && (d = d + v);
    }
  } else if (n.message === "index" && (d = Number(n.index), d === y))
    return null;
  return d;
}, $n = (e) => e.targetSlideGroupIndex > e.currentSlideGroupIndex ? e.targetSlideGroupIndex > e.currentSlideGroupIndex + jn(e) ? "left" : "right" : e.targetSlideGroupIndex < e.currentSlideGroupIndex - Pn(e) ? "right" : "left", jn = ({
  groupsToShow: e,
  centerMode: n,
  rtl: r,
  centerPadding: i
}) => {
  if (n) {
    let a = (e - 1) / 2 + 1;
    return parseInt(i) > 0 && (a += 1), r && e % 2 === 0 && (a += 1), a;
  }
  return r ? 0 : e - 1;
}, Pn = ({
  groupsToShow: e,
  centerMode: n,
  rtl: r,
  centerPadding: i
}) => {
  if (n) {
    let a = (e - 1) / 2 + 1;
    return parseInt(i) > 0 && (a += 1), !r && e % 2 === 0 && (a += 1), a;
  }
  return r ? e - 1 : 0;
}, Nn = (e) => {
  let n = e.infinite ? e.slideGroupCount * 2 : e.slideGroupCount, r = e.infinite ? e.groupsToShow * -1 : 0, i = e.infinite ? e.groupsToShow * -1 : 0, a = [];
  for (; r < n; )
    a.push(r), r = i + e.groupsToScroll, i += Math.min(e.groupsToScroll, e.groupsToShow);
  return a;
}, rr = (e, n) => {
  const r = Nn(e);
  let i = 0;
  if (n > r[r.length - 1])
    n = r[r.length - 1];
  else
    for (let a in r) {
      if (n < r[a]) {
        n = i;
        break;
      }
      i = r[a];
    }
  return n;
}, Wn = (e, n, r) => {
  if (!(!n || !r && e.type.indexOf("mouse") !== -1))
    return {
      dragging: !0,
      touchObject: {
        startX: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX,
        startY: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY,
        curX: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX,
        curY: window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY
      }
    };
}, nr = (e) => {
  var C;
  const n = e.centerMode ? +e.slideGroupWidth * Math.floor(e.groupsToShow / 2) : 0;
  let r;
  const a = e.listEl.querySelectorAll(
    ".v-slick-slide-group"
  );
  if (Array.from(a).every((v) => {
    if (e.vertical) {
      if (v.offsetTop + v.offsetHeight / 2 > e.swipeLeft * -1)
        return r = v, !1;
    } else if (v.offsetLeft - n + v.offsetWidth / 2 > e.swipeLeft * -1)
      return r = v, !1;
    return !0;
  }), !r)
    return 0;
  const s = e.rtl === !0 ? e.slideGroupCount - e.currentSlideGroupIndex : e.currentSlideGroupIndex, d = (C = r == null ? void 0 : r.dataset) == null ? void 0 : C.index;
  return Math.abs(
    d ? parseInt(d) : 0 - s
  );
}, gr = (e, n = !1) => {
  let r, i, a, s;
  return r = e.startX - e.curX, i = e.startY - e.curY, a = Math.atan2(i, r), s = Math.round(a * 180 / Math.PI), s < 0 && (s = 360 - Math.abs(s)), s <= 45 && s >= 0 || s <= 360 && s >= 315 ? le.left : s >= 135 && s <= 225 ? le.right : n === !0 ? s >= 35 && s <= 135 ? le.up : le.down : le.vertical;
}, Hn = (e, n) => {
  const {
    dragging: r,
    swipe: i,
    touchObject: a,
    listWidth: s,
    touchThreshold: d,
    verticalSwiping: g,
    listHeight: C,
    currentSlideGroupIndex: v,
    swipeToSlide: y,
    scrolling: h,
    onSwipe: w,
    rtl: b
  } = n;
  if (!r) {
    i && e.preventDefault();
    return;
  }
  let G = g ? C / d : s / d, L = gr(a, g);
  b && (L === le.left ? L = le.right : L === le.right && (L = le.left));
  let $ = {
    dragging: !1,
    edgeDragged: !1,
    scrolling: !1,
    swiping: !1,
    swiped: !1,
    swipeLeft: null,
    touchObject: {}
  };
  if (h || !a.swipeLength)
    return $;
  if (a.swipeLength > G) {
    e.preventDefault(), w && w(L);
    let m, M;
    switch (L) {
      case "left":
      case "up":
        M = n.swipeToSlide ? nr(n) : v + n.groupsToScroll, m = y ? rr(n, M) : M, $.currentDirection = 0;
        break;
      case "right":
      case "down":
        M = n.swipeToSlide ? nr(n) : v - n.groupsToScroll, m = y ? rr(n, M) : M, $.currentDirection = 1;
        break;
      default:
        m = v;
    }
    $.triggerSlideGroupHandler = m;
  } else {
    let m = Ve(n);
    $.trackStyle = mr(n, m);
  }
  return $;
};
function zn(e) {
  return e.centerMode ? Math.floor(e.groupsToShow / 2) + (parseInt(e.centerPadding) > 0 ? 1 : 0) : 0;
}
function Dn(e) {
  return e.centerMode ? Math.floor((e.groupsToShow - 1) / 2) + 1 + (parseInt(e.centerPadding) > 0 ? 1 : 0) : e.groupsToShow;
}
function yr(e) {
  return e.currentSlideGroupIndex - zn(e);
}
function Sr(e) {
  return e.currentSlideGroupIndex + Dn(e);
}
function Pt(e) {
  var a;
  let n = [];
  const r = yr(e), i = Sr(e);
  for (let s = r; s < i; s++)
    ((a = e.lazyLoadedList) == null ? void 0 : a.indexOf(s)) < 0 && n.push(s);
  return n;
}
function Re(e, n) {
  let r, i;
  const a = e.slideGroupCount + 2 * e.groupsToShow;
  e.vertical ? i = a * parseInt(`${e.slideGroupHeight || 0}`) : r = Bn(e) * parseInt(`${e.slideGroupWidth || 0}`);
  let s = {
    opacity: 1,
    transition: ""
  };
  if (e.useCSSTransform) {
    let d = e.vertical ? "translate3d(0px, " + n + "px, 0px)" : "translate3d(" + n + "px, 0px, 0px)";
    s = {
      ...s,
      transform: d
    };
  } else
    e.vertical ? s.top = n : s.left = n;
  return e.fade && (s = { opacity: 1 }), r && (s.width = r + "px"), i && (s.height = i + "px"), s;
}
function Bn(e) {
  return e.slideGroupCount <= e.groupsToShow ? e.slideGroupCount : be(e) + e.slideGroupCount + Et(e);
}
function mr(e, n) {
  let r = Re(e, n);
  return e.useCSSTransform ? r.transition = "transform " + e.speed + "ms " + e.cssEase : e.vertical ? r.transition = "top " + e.speed + "ms " + e.cssEase : r.transition = "left " + e.speed + "ms " + e.cssEase, e.ignorePrefersReducedMotion && (r.transition += " !important"), r;
}
function Ve(e) {
  let {
    centerPadding: n,
    currentSlideGroupIndex: r,
    trackEl: i,
    infinite: a,
    centerMode: s,
    slideGroupCount: d,
    groupsToShow: g,
    groupsToScroll: C,
    slideGroupWidth: v,
    listWidth: y,
    variableWidth: h,
    slideGroupHeight: w,
    fade: b,
    vertical: G,
    rtl: L
  } = e;
  y = y || 0, v = v || 0, w = w || 0;
  let $ = 0, m, M, V = 0;
  if (b || d === 1)
    return 0;
  let B = 0;
  if (a ? (B = -be(e), d % C !== 0 && r + C > d && (B = -(r > d ? g - (r - d) : d % C)), s && (B += Math.floor(g / 2))) : (d % C !== 0 && r + C > d && (B = g - d % C), s && (B = Math.floor(g / 2))), $ = B * parseInt(`${v}`), V = B * parseInt(`${w}`), G ? m = r * parseInt(`${w}`) * -1 + V : m = r * parseInt(`${v}`) * -1 + $, h === !0) {
    let W;
    if (W = r + be(e), M = i && i.childNodes[W], m = M ? M.offsetLeft * -1 : 0, s === !0) {
      W = a ? r + be(e) : r, M = i && i.children[W], m = 0;
      for (let I = 0; I < W; I++)
        m -= i && i.children[I] && i.children[I].offsetWidth;
      m -= parseInt(n), m += M && (y - M.offsetWidth) / 2;
    }
  }
  return L && (m = -m), m;
}
const Nt = (e) => {
  let n = !0;
  return e.infinite || (e.centerMode && e.currentSlideGroupIndex >= e.slideGroupCount - 1 || e.slideGroupCount <= e.groupsToShow || e.currentSlideGroupIndex >= e.slideGroupCount - e.groupsToShow) && (n = !1), n;
}, Fn = (e) => {
  const {
    waitForAnimate: n,
    animating: r,
    fade: i,
    infinite: a,
    index: s,
    slideGroupCount: d,
    lazyLoadedList: g,
    lazyLoad: C,
    currentSlideGroupIndex: v,
    centerMode: y,
    groupsToScroll: h,
    groupsToShow: w,
    useCSSTransitions: b
  } = e;
  if (n && r) return {};
  let G = s, L, $, m, M = {}, V = {};
  if (i) {
    if (!a && (s < 0 || s >= d)) return {};
    s < 0 ? G = s + d : s >= d && (G = s - d), C && g.indexOf(G) < 0 && g.push(G), M = {
      animating: !0,
      currentSlideGroupIndex: G,
      lazyLoadedList: g
    }, V = { animating: !1 };
  } else
    L = G, G < 0 ? (L = G + d, a ? d % h !== 0 && (L = d - d % h) : L = 0) : !Nt(e) && G > v ? G = L = v : y && G >= d ? (G = a ? d : d - 1, L = a ? 0 : d - 1) : G >= d && (L = G - d, a ? d % h !== 0 && (L = 0) : L = d - w), m = Ve({
      ...e,
      currentSlideGroupIndex: L
    }), $ = Ve({
      ...e,
      currentSlideGroupIndex: G
    }), a || ($ === m && (G = L), $ = m), C && g.concat(
      Pt({
        ...e,
        currentSlideGroupIndex: G
      })
    ), b ? (M = {
      animating: !0,
      currentSlideGroupIndex: L,
      trackStyle: mr(e, $),
      lazyLoadedList: g
    }, V = {
      animating: !1,
      currentSlideGroupIndex: L,
      trackStyle: Re(e, m),
      swipeLeft: void 0
    }) : M = {
      currentSlideGroupIndex: L,
      trackStyle: Re(e, m),
      lazyLoadedList: g
    };
  return { slidingState: M, afterSlidingState: V };
};
function be(e) {
  return e.infinite ? e.variableWidth ? e.slideGroupCount : e.groupsToShow + (e.centerMode ? 1 : 0) : 0;
}
function Et(e) {
  return e.infinite ? e.slideGroupCount : 0;
}
const Rn = (e, n) => {
  const {
    scrolling: r,
    animating: i,
    vertical: a,
    swipeToSlide: s,
    verticalSwiping: d,
    rtl: g,
    currentSlideGroupIndex: C,
    edgeFriction: v,
    edgeDragged: y,
    onEdge: h,
    swiped: w,
    swiping: b,
    slideGroupCount: G,
    groupsToScroll: L,
    infinite: $,
    touchObject: m,
    swipeEvent: M,
    listHeight: V,
    listWidth: B
  } = n;
  if (r) return;
  if (i) {
    e.preventDefault();
    return;
  }
  a && s && d && e.preventDefault();
  let W, I = {}, N = Ve(n);
  m.curX = window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageX : e.clientX, m.curY = window.TouchEvent && e instanceof TouchEvent ? e.touches[0].pageY : e.clientY, m.swipeLength = Math.round(
    Math.sqrt(Math.pow(m.curX - m.startX, 2))
  );
  let D = Math.round(
    Math.sqrt(Math.pow(m.curY - m.startY, 2))
  );
  if (!d && !b && D > 10)
    return { scrolling: !0 };
  d && (m.swipeLength = D);
  let X = (g ? -1 : 1) * (m.curX > m.startX ? 1 : -1);
  d && (X = m.curY > m.startY ? 1 : -1);
  let Ge = Math.ceil(G / L), ee = gr(n.touchObject, d), te = m.swipeLength;
  return $ || (C === 0 && ee === "right" || C + 1 >= Ge && ee === "left" || !Nt(n) && ee === "left") && (te = Math.round(m.swipeLength * v), y === !1 && h && (h(ee), I.edgeDragged = !0)), !w && M && (M(ee), I.swiped = !0), a ? W = N + te * (V / B) * X : g ? W = N - te * X : W = N + te * X, d && (W = N + te * X), I = {
    ...I,
    touchObject: m,
    swipeLeft: W,
    trackStyle: Re(n, W)
  }, Math.abs(m.curX - m.startX) < Math.abs(m.curY - m.startY) * 0.8 || m.swipeLength > 10 && (I.swiping = !0, e.preventDefault()), I;
};
function wr(e, n) {
  return Math.ceil(e / n);
}
function Vn(e) {
  var h, w, b;
  let n = wr(
    e.slides.length,
    e.groupsToShow
  ), r = Math.ceil(((h = e.listEl) == null ? void 0 : h.offsetWidth) || 0), i = Math.ceil(((w = e.trackEl) == null ? void 0 : w.offsetWidth) || 0), a;
  if (e.vertical)
    a = r;
  else {
    let G = e.centerMode ? parseInt(e.centerPadding) * 2 : 0;
    typeof e.centerPadding == "string" && e.centerPadding.slice(-1) === "%" && (G *= r / 100), a = Math.ceil(
      (r - G) / e.groupsToShow
    );
  }
  let s = e.listEl && e.listEl.querySelector('[data-index="0"]') && ((b = e.listEl.querySelector('[data-index="0"]')) == null ? void 0 : b.offsetHeight) || 0, d = s * e.groupsToShow, g = e.currentSlideGroupIndex === void 0 ? e.initialGroupIndex : e.currentSlideGroupIndex;
  e.rtl && e.currentSlideGroupIndex === void 0 && (g = n - 1 - e.initialGroupIndex);
  let C = e.lazyLoadedList || [], v = Pt(e);
  C.concat(v);
  let y = {
    slideGroupCount: n,
    slideGroupWidth: a,
    listWidth: r,
    trackWidth: i,
    currentSlideGroupIndex: g,
    slideGroupHeight: s,
    listHeight: d,
    lazyLoadedList: C
  };
  return e.autoplaying === null && e.autoplay && (y.autoplaying = _.playing), y;
}
const Xn = () => !!(typeof window < "u" && window.document && window.document.createElement), or = (e) => Object.keys(e).filter((n) => e[n] !== void 0).reduce((n, r) => (n[r] = e[r], n), {});
function Un() {
  var e, n;
  window.getSelection && ((e = window.getSelection()) != null && e.empty ? window.getSelection().empty() : (n = window.getSelection()) != null && n.removeAllRanges && window.getSelection().removeAllRanges());
}
var Z = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Xe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Yn = 1 / 0, qn = 9007199254740991, Kn = "[object Arguments]", Qn = "[object Function]", Zn = "[object GeneratorFunction]", Jn = "[object Symbol]", eo = typeof Z == "object" && Z && Z.Object === Object && Z, to = typeof self == "object" && self && self.Object === Object && self, ro = eo || to || Function("return this")();
function no(e, n, r) {
  switch (r.length) {
    case 0:
      return e.call(n);
    case 1:
      return e.call(n, r[0]);
    case 2:
      return e.call(n, r[0], r[1]);
    case 3:
      return e.call(n, r[0], r[1], r[2]);
  }
  return e.apply(n, r);
}
function oo(e, n) {
  for (var r = -1, i = e ? e.length : 0, a = Array(i); ++r < i; )
    a[r] = n(e[r], r, e);
  return a;
}
function io(e, n) {
  for (var r = -1, i = n.length, a = e.length; ++r < i; )
    e[a + r] = n[r];
  return e;
}
var Wt = Object.prototype, lo = Wt.hasOwnProperty, Ht = Wt.toString, ir = ro.Symbol, ao = Wt.propertyIsEnumerable, lr = ir ? ir.isConcatSpreadable : void 0, ar = Math.max;
function uo(e, n, r, i, a) {
  var s = -1, d = e.length;
  for (r || (r = po), a || (a = []); ++s < d; ) {
    var g = e[s];
    r(g) ? io(a, g) : a[a.length] = g;
  }
  return a;
}
function so(e, n) {
  return e = Object(e), co(e, n, function(r, i) {
    return i in e;
  });
}
function co(e, n, r) {
  for (var i = -1, a = n.length, s = {}; ++i < a; ) {
    var d = n[i], g = e[d];
    r(g, d) && (s[d] = g);
  }
  return s;
}
function fo(e, n) {
  return n = ar(n === void 0 ? e.length - 1 : n, 0), function() {
    for (var r = arguments, i = -1, a = ar(r.length - n, 0), s = Array(a); ++i < a; )
      s[i] = r[n + i];
    i = -1;
    for (var d = Array(n + 1); ++i < n; )
      d[i] = r[i];
    return d[n] = s, no(e, this, d);
  };
}
function po(e) {
  return go(e) || vo(e) || !!(lr && e && e[lr]);
}
function ho(e) {
  if (typeof e == "string" || Go(e))
    return e;
  var n = e + "";
  return n == "0" && 1 / e == -Yn ? "-0" : n;
}
function vo(e) {
  return So(e) && lo.call(e, "callee") && (!ao.call(e, "callee") || Ht.call(e) == Kn);
}
var go = Array.isArray;
function yo(e) {
  return e != null && wo(e.length) && !mo(e);
}
function So(e) {
  return br(e) && yo(e);
}
function mo(e) {
  var n = bo(e) ? Ht.call(e) : "";
  return n == Qn || n == Zn;
}
function wo(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= qn;
}
function bo(e) {
  var n = typeof e;
  return !!e && (n == "object" || n == "function");
}
function br(e) {
  return !!e && typeof e == "object";
}
function Go(e) {
  return typeof e == "symbol" || br(e) && Ht.call(e) == Jn;
}
var To = fo(function(e, n) {
  return e == null ? {} : so(e, oo(uo(n), ho));
}), xo = To;
const zt = /* @__PURE__ */ Xe(xo);
var ut = { exports: {} };
ut.exports;
(function(e, n) {
  var r = 200, i = "__lodash_hash_undefined__", a = 9007199254740991, s = "[object Arguments]", d = "[object Array]", g = "[object Boolean]", C = "[object Date]", v = "[object Error]", y = "[object Function]", h = "[object GeneratorFunction]", w = "[object Map]", b = "[object Number]", G = "[object Object]", L = "[object Promise]", $ = "[object RegExp]", m = "[object Set]", M = "[object String]", V = "[object Symbol]", B = "[object WeakMap]", W = "[object ArrayBuffer]", I = "[object DataView]", N = "[object Float32Array]", D = "[object Float64Array]", X = "[object Int8Array]", Ge = "[object Int16Array]", ee = "[object Int32Array]", te = "[object Uint8Array]", Ue = "[object Uint8ClampedArray]", Ye = "[object Uint16Array]", $e = "[object Uint32Array]", qe = /[\\^$.*+?()[\]{}|]/g, Ke = /\w*$/, Qe = /^\[object .+?Constructor\]$/, Ze = /^(?:0|[1-9]\d*)$/, A = {};
  A[s] = A[d] = A[W] = A[I] = A[g] = A[C] = A[N] = A[D] = A[X] = A[Ge] = A[ee] = A[w] = A[b] = A[G] = A[$] = A[m] = A[M] = A[V] = A[te] = A[Ue] = A[Ye] = A[$e] = !0, A[v] = A[y] = A[B] = !1;
  var dt = typeof Z == "object" && Z && Z.Object === Object && Z, ft = typeof self == "object" && self && self.Object === Object && self, J = dt || ft || Function("return this")(), Je = n && !n.nodeType && n, et = Je && !0 && e && !e.nodeType && e, ce = et && et.exports === Je;
  function ae(t, o) {
    return t.set(o[0], o[1]), t;
  }
  function je(t, o) {
    return t.add(o), t;
  }
  function pt(t, o) {
    for (var u = -1, S = t ? t.length : 0; ++u < S && o(t[u], u, t) !== !1; )
      ;
    return t;
  }
  function de(t, o) {
    for (var u = -1, S = o.length, F = t.length; ++u < S; )
      t[F + u] = o[u];
    return t;
  }
  function Pe(t, o, u, S) {
    for (var F = -1, Y = t ? t.length : 0; ++F < Y; )
      u = o(u, t[F], F, t);
    return u;
  }
  function ht(t, o) {
    for (var u = -1, S = Array(t); ++u < t; )
      S[u] = o(u);
    return S;
  }
  function vt(t, o) {
    return t == null ? void 0 : t[o];
  }
  function tt(t) {
    var o = !1;
    if (t != null && typeof t.toString != "function")
      try {
        o = !!(t + "");
      } catch {
      }
    return o;
  }
  function rt(t) {
    var o = -1, u = Array(t.size);
    return t.forEach(function(S, F) {
      u[++o] = [F, S];
    }), u;
  }
  function Ne(t, o) {
    return function(u) {
      return t(o(u));
    };
  }
  function pe(t) {
    var o = -1, u = Array(t.size);
    return t.forEach(function(S) {
      u[++o] = S;
    }), u;
  }
  var j = Array.prototype, re = Function.prototype, f = Object.prototype, he = J["__core-js_shared__"], ve = function() {
    var t = /[^.]+$/.exec(he && he.keys && he.keys.IE_PROTO || "");
    return t ? "Symbol(src)_1." + t : "";
  }(), p = re.toString, ne = f.hasOwnProperty, Te = f.toString, P = RegExp(
    "^" + p.call(ne).replace(qe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), We = ce ? J.Buffer : void 0, He = J.Symbol, ze = J.Uint8Array, nt = Ne(Object.getPrototypeOf, Object), l = Object.create, c = f.propertyIsEnumerable, x = j.splice, T = Object.getOwnPropertySymbols, k = We ? We.isBuffer : void 0, O = Ne(Object.keys, Object), H = Ce(J, "DataView"), E = Ce(J, "Map"), R = Ce(J, "Promise"), fe = Ce(J, "Set"), oe = Ce(J, "WeakMap"), ie = Ce(Object, "create"), gt = Se(H), Tr = Se(E), xr = Se(R), kr = Se(fe), Cr = Se(oe), Ft = He ? He.prototype : void 0, Rt = Ft ? Ft.valueOf : void 0;
  function ge(t) {
    var o = -1, u = t ? t.length : 0;
    for (this.clear(); ++o < u; ) {
      var S = t[o];
      this.set(S[0], S[1]);
    }
  }
  function Ir() {
    this.__data__ = ie ? ie(null) : {};
  }
  function Lr(t) {
    return this.has(t) && delete this.__data__[t];
  }
  function _r(t) {
    var o = this.__data__;
    if (ie) {
      var u = o[t];
      return u === i ? void 0 : u;
    }
    return ne.call(o, t) ? o[t] : void 0;
  }
  function Or(t) {
    var o = this.__data__;
    return ie ? o[t] !== void 0 : ne.call(o, t);
  }
  function Er(t, o) {
    var u = this.__data__;
    return u[t] = ie && o === void 0 ? i : o, this;
  }
  ge.prototype.clear = Ir, ge.prototype.delete = Lr, ge.prototype.get = _r, ge.prototype.has = Or, ge.prototype.set = Er;
  function ue(t) {
    var o = -1, u = t ? t.length : 0;
    for (this.clear(); ++o < u; ) {
      var S = t[o];
      this.set(S[0], S[1]);
    }
  }
  function Mr() {
    this.__data__ = [];
  }
  function Ar(t) {
    var o = this.__data__, u = ot(o, t);
    if (u < 0)
      return !1;
    var S = o.length - 1;
    return u == S ? o.pop() : x.call(o, u, 1), !0;
  }
  function $r(t) {
    var o = this.__data__, u = ot(o, t);
    return u < 0 ? void 0 : o[u][1];
  }
  function jr(t) {
    return ot(this.__data__, t) > -1;
  }
  function Pr(t, o) {
    var u = this.__data__, S = ot(u, t);
    return S < 0 ? u.push([t, o]) : u[S][1] = o, this;
  }
  ue.prototype.clear = Mr, ue.prototype.delete = Ar, ue.prototype.get = $r, ue.prototype.has = jr, ue.prototype.set = Pr;
  function xe(t) {
    var o = -1, u = t ? t.length : 0;
    for (this.clear(); ++o < u; ) {
      var S = t[o];
      this.set(S[0], S[1]);
    }
  }
  function Nr() {
    this.__data__ = {
      hash: new ge(),
      map: new (E || ue)(),
      string: new ge()
    };
  }
  function Wr(t) {
    return it(this, t).delete(t);
  }
  function Hr(t) {
    return it(this, t).get(t);
  }
  function zr(t) {
    return it(this, t).has(t);
  }
  function Dr(t, o) {
    return it(this, t).set(t, o), this;
  }
  xe.prototype.clear = Nr, xe.prototype.delete = Wr, xe.prototype.get = Hr, xe.prototype.has = zr, xe.prototype.set = Dr;
  function ke(t) {
    this.__data__ = new ue(t);
  }
  function Br() {
    this.__data__ = new ue();
  }
  function Fr(t) {
    return this.__data__.delete(t);
  }
  function Rr(t) {
    return this.__data__.get(t);
  }
  function Vr(t) {
    return this.__data__.has(t);
  }
  function Xr(t, o) {
    var u = this.__data__;
    if (u instanceof ue) {
      var S = u.__data__;
      if (!E || S.length < r - 1)
        return S.push([t, o]), this;
      u = this.__data__ = new xe(S);
    }
    return u.set(t, o), this;
  }
  ke.prototype.clear = Br, ke.prototype.delete = Fr, ke.prototype.get = Rr, ke.prototype.has = Vr, ke.prototype.set = Xr;
  function Ur(t, o) {
    var u = mt(t) || Sn(t) ? ht(t.length, String) : [], S = u.length, F = !!S;
    for (var Y in t)
      ne.call(t, Y) && !(F && (Y == "length" || hn(Y, S))) && u.push(Y);
    return u;
  }
  function Vt(t, o, u) {
    var S = t[o];
    (!(ne.call(t, o) && qt(S, u)) || u === void 0 && !(o in t)) && (t[o] = u);
  }
  function ot(t, o) {
    for (var u = t.length; u--; )
      if (qt(t[u][0], o))
        return u;
    return -1;
  }
  function Yr(t, o) {
    return t && Xt(o, wt(o), t);
  }
  function yt(t, o, u, S, F, Y, se) {
    var q;
    if (S && (q = Y ? S(t, F, Y, se) : S(t)), q !== void 0)
      return q;
    if (!lt(t))
      return t;
    var Zt = mt(t);
    if (Zt) {
      if (q = dn(t), !o)
        return un(t, q);
    } else {
      var Ie = ye(t), Jt = Ie == y || Ie == h;
      if (wn(t))
        return en(t, o);
      if (Ie == G || Ie == s || Jt && !Y) {
        if (tt(t))
          return Y ? t : {};
        if (q = fn(Jt ? {} : t), !o)
          return sn(t, Yr(q, t));
      } else {
        if (!A[Ie])
          return Y ? t : {};
        q = pn(t, Ie, yt, o);
      }
    }
    se || (se = new ke());
    var er = se.get(t);
    if (er)
      return er;
    if (se.set(t, q), !Zt)
      var tr = u ? cn(t) : wt(t);
    return pt(tr || t, function(bt, at) {
      tr && (at = bt, bt = t[at]), Vt(q, at, yt(bt, o, u, S, at, t, se));
    }), q;
  }
  function qr(t) {
    return lt(t) ? l(t) : {};
  }
  function Kr(t, o, u) {
    var S = o(t);
    return mt(t) ? S : de(S, u(t));
  }
  function Qr(t) {
    return Te.call(t);
  }
  function Zr(t) {
    if (!lt(t) || gn(t))
      return !1;
    var o = Qt(t) || tt(t) ? P : Qe;
    return o.test(Se(t));
  }
  function Jr(t) {
    if (!Yt(t))
      return O(t);
    var o = [];
    for (var u in Object(t))
      ne.call(t, u) && u != "constructor" && o.push(u);
    return o;
  }
  function en(t, o) {
    if (o)
      return t.slice();
    var u = new t.constructor(t.length);
    return t.copy(u), u;
  }
  function St(t) {
    var o = new t.constructor(t.byteLength);
    return new ze(o).set(new ze(t)), o;
  }
  function tn(t, o) {
    var u = o ? St(t.buffer) : t.buffer;
    return new t.constructor(u, t.byteOffset, t.byteLength);
  }
  function rn(t, o, u) {
    var S = o ? u(rt(t), !0) : rt(t);
    return Pe(S, ae, new t.constructor());
  }
  function nn(t) {
    var o = new t.constructor(t.source, Ke.exec(t));
    return o.lastIndex = t.lastIndex, o;
  }
  function on(t, o, u) {
    var S = o ? u(pe(t), !0) : pe(t);
    return Pe(S, je, new t.constructor());
  }
  function ln(t) {
    return Rt ? Object(Rt.call(t)) : {};
  }
  function an(t, o) {
    var u = o ? St(t.buffer) : t.buffer;
    return new t.constructor(u, t.byteOffset, t.length);
  }
  function un(t, o) {
    var u = -1, S = t.length;
    for (o || (o = Array(S)); ++u < S; )
      o[u] = t[u];
    return o;
  }
  function Xt(t, o, u, S) {
    u || (u = {});
    for (var F = -1, Y = o.length; ++F < Y; ) {
      var se = o[F], q = void 0;
      Vt(u, se, q === void 0 ? t[se] : q);
    }
    return u;
  }
  function sn(t, o) {
    return Xt(t, Ut(t), o);
  }
  function cn(t) {
    return Kr(t, wt, Ut);
  }
  function it(t, o) {
    var u = t.__data__;
    return vn(o) ? u[typeof o == "string" ? "string" : "hash"] : u.map;
  }
  function Ce(t, o) {
    var u = vt(t, o);
    return Zr(u) ? u : void 0;
  }
  var Ut = T ? Ne(T, Object) : Tn, ye = Qr;
  (H && ye(new H(new ArrayBuffer(1))) != I || E && ye(new E()) != w || R && ye(R.resolve()) != L || fe && ye(new fe()) != m || oe && ye(new oe()) != B) && (ye = function(t) {
    var o = Te.call(t), u = o == G ? t.constructor : void 0, S = u ? Se(u) : void 0;
    if (S)
      switch (S) {
        case gt:
          return I;
        case Tr:
          return w;
        case xr:
          return L;
        case kr:
          return m;
        case Cr:
          return B;
      }
    return o;
  });
  function dn(t) {
    var o = t.length, u = t.constructor(o);
    return o && typeof t[0] == "string" && ne.call(t, "index") && (u.index = t.index, u.input = t.input), u;
  }
  function fn(t) {
    return typeof t.constructor == "function" && !Yt(t) ? qr(nt(t)) : {};
  }
  function pn(t, o, u, S) {
    var F = t.constructor;
    switch (o) {
      case W:
        return St(t);
      case g:
      case C:
        return new F(+t);
      case I:
        return tn(t, S);
      case N:
      case D:
      case X:
      case Ge:
      case ee:
      case te:
      case Ue:
      case Ye:
      case $e:
        return an(t, S);
      case w:
        return rn(t, S, u);
      case b:
      case M:
        return new F(t);
      case $:
        return nn(t);
      case m:
        return on(t, S, u);
      case V:
        return ln(t);
    }
  }
  function hn(t, o) {
    return o = o ?? a, !!o && (typeof t == "number" || Ze.test(t)) && t > -1 && t % 1 == 0 && t < o;
  }
  function vn(t) {
    var o = typeof t;
    return o == "string" || o == "number" || o == "symbol" || o == "boolean" ? t !== "__proto__" : t === null;
  }
  function gn(t) {
    return !!ve && ve in t;
  }
  function Yt(t) {
    var o = t && t.constructor, u = typeof o == "function" && o.prototype || f;
    return t === u;
  }
  function Se(t) {
    if (t != null) {
      try {
        return p.call(t);
      } catch {
      }
      try {
        return t + "";
      } catch {
      }
    }
    return "";
  }
  function yn(t) {
    return yt(t, !0, !0);
  }
  function qt(t, o) {
    return t === o || t !== t && o !== o;
  }
  function Sn(t) {
    return mn(t) && ne.call(t, "callee") && (!c.call(t, "callee") || Te.call(t) == s);
  }
  var mt = Array.isArray;
  function Kt(t) {
    return t != null && bn(t.length) && !Qt(t);
  }
  function mn(t) {
    return Gn(t) && Kt(t);
  }
  var wn = k || xn;
  function Qt(t) {
    var o = lt(t) ? Te.call(t) : "";
    return o == y || o == h;
  }
  function bn(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= a;
  }
  function lt(t) {
    var o = typeof t;
    return !!t && (o == "object" || o == "function");
  }
  function Gn(t) {
    return !!t && typeof t == "object";
  }
  function wt(t) {
    return Kt(t) ? Ur(t) : Jr(t);
  }
  function Tn() {
    return [];
  }
  function xn() {
    return !1;
  }
  e.exports = yn;
})(ut, ut.exports);
var ko = ut.exports;
const ct = /* @__PURE__ */ Xe(ko), Ae = {
  accessibility: { type: Boolean, default: !0 },
  adaptiveHeight: { type: Boolean, default: !1 },
  arrows: { type: Boolean, default: !0 },
  asNavFor: {
    type: Object,
    default: null
  },
  autoplay: { type: Boolean, default: !1 },
  autoplaySpeed: { type: Number, default: 3e3 },
  centerMode: { type: Boolean, default: !1 },
  centerPadding: { type: String, default: "50px" },
  cssEase: { type: String, default: "ease" },
  dots: { type: Boolean, default: !1 },
  dotsClass: { type: String, default: "v-slick-dots" },
  draggable: { type: Boolean, default: !0 },
  edgeFriction: { type: Number, default: 0.35 },
  fade: { type: Boolean, default: !1 },
  focusOnSelect: { type: Boolean, default: !1 },
  ignorePrefersReducedMotion: { type: Boolean, default: !1 },
  infinite: { type: Boolean, default: !0 },
  initialGroupIndex: { type: Number, default: 0 },
  lazyLoad: { type: String, default: null },
  nextArrowLabel: { type: String, default: "Next" },
  pauseOnDotsHover: { type: Boolean, default: !1 },
  pauseOnFocus: { type: Boolean, default: !1 },
  pauseOnHover: { type: Boolean, default: !0 },
  prevArrowLabel: { type: String, default: "Previous" },
  responsive: { type: Array, default: [] },
  rtl: { type: Boolean, default: !1 },
  slidesPerGroup: { type: Number, default: 1 },
  groupsToScroll: { type: Number, default: 1 },
  groupsToShow: { type: Number, default: 1 },
  speed: { type: Number, default: 500 },
  swipe: { type: Boolean, default: !0 },
  swipeToSlide: { type: Boolean, default: !1 },
  touchMove: { type: Boolean, default: !0 },
  touchThreshold: { type: Number, default: 5 },
  useCSSTransitions: { type: Boolean, default: !0 },
  useCSSTransform: { type: Boolean, default: !0 },
  variableWidth: { type: Boolean, default: !1 },
  vertical: { type: Boolean, default: !1 },
  verticalSwiping: { type: Boolean, default: !1 },
  waitForAnimate: { type: Boolean, default: !0 }
}, Co = Object.keys(Ae).reduce((e, n) => (e[n] = Ae[n].default, e), {}), Io = {
  animating: !1,
  autoplaying: null,
  autoplayTimer: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlideGroupIndex: 0,
  direction: 1,
  dragging: !1,
  edgeDragged: !1,
  initialized: !1,
  lazyLoadedList: [],
  listHeight: void 0,
  listWidth: void 0,
  scrolling: !1,
  slideGroupHeight: void 0,
  slideGroupWidth: void 0,
  swipeLeft: void 0,
  swiped: !1,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: !1,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0, swipeLength: 0 },
  trackStyle: {},
  trackWidth: 0
}, Lo = {
  ...zt(ct(Ae), [
    "centerMode",
    "centerPadding",
    "cssEase",
    "fade",
    "ignorePrefersReducedMotion",
    "infinite",
    "lazyLoad",
    "rtl",
    "groupsToScroll",
    "groupsToShow",
    "speed",
    "variableWidth",
    "vertical"
  ]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  lazyLoadedList: {
    type: Array,
    default: []
  },
  listHeight: { type: Number, default: void 0 },
  trackStyle: { type: Object, default: {} },
  slideGroupCount: { type: Number, default: 0 },
  rawSlideGroups: { type: Array, default: [] },
  slideGroupHeight: { type: [String, Number], default: void 0 },
  slideGroupWidth: { type: [String, Number], default: void 0 }
}, _o = {
  ...zt(ct(Ae), [
    "centerMode",
    "infinite",
    "groupsToShow",
    "prevArrowLabel",
    "nextArrowLabel"
  ]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  slideGroupCount: { type: Number, default: 0 },
  type: { type: String, default: "prev" }
}, Oo = {
  ...zt(ct(Ae), [
    "dotsClass",
    "infinite",
    "groupsToScroll",
    "groupsToShow"
  ]),
  currentSlideGroupIndex: { type: Number, default: 0 },
  slideGroupCount: { type: Number, default: 0 },
  pageCount: { type: Number, default: 0 }
};
function Mt(e) {
  this.options = e, !e.deferSetup && this.setup();
}
Mt.prototype = {
  constructor: Mt,
  /**
   * coordinates setup of the handler
   *
   * @function
   */
  setup: function() {
    this.options.setup && this.options.setup(), this.initialised = !0;
  },
  /**
   * coordinates setup and triggering of the handler
   *
   * @function
   */
  on: function() {
    !this.initialised && this.setup(), this.options.match && this.options.match();
  },
  /**
   * coordinates the unmatch event for the handler
   *
   * @function
   */
  off: function() {
    this.options.unmatch && this.options.unmatch();
  },
  /**
   * called when a handler is to be destroyed.
   * delegates to the destroy or unmatch callbacks, depending on availability.
   *
   * @function
   */
  destroy: function() {
    this.options.destroy ? this.options.destroy() : this.off();
  },
  /**
   * determines equality by reference.
   * if object is supplied compare options, if function, compare match callback
   *
   * @function
   * @param {object || function} [target] the target for comparison
   */
  equals: function(e) {
    return this.options === e || this.options.match === e;
  }
};
var Eo = Mt;
function Mo(e, n) {
  var r = 0, i = e.length, a;
  for (r; r < i && (a = n(e[r], r), a !== !1); r++)
    ;
}
function Ao(e) {
  return Object.prototype.toString.apply(e) === "[object Array]";
}
function $o(e) {
  return typeof e == "function";
}
var Gr = {
  isFunction: $o,
  isArray: Ao,
  each: Mo
}, jo = Eo, Ct = Gr.each;
function At(e, n) {
  this.query = e, this.isUnconditional = n, this.handlers = [], this.mql = window == null ? void 0 : window.matchMedia(e);
  var r = this;
  this.listener = function(i) {
    r.mql = i.currentTarget || i, r.assess();
  }, this.mql.addListener(this.listener);
}
At.prototype = {
  constuctor: At,
  /**
   * add a handler for this query, triggering if already active
   *
   * @param {object} handler
   * @param {function} handler.match callback for when query is activated
   * @param {function} [handler.unmatch] callback for when query is deactivated
   * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
   * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
   */
  addHandler: function(e) {
    var n = new jo(e);
    this.handlers.push(n), this.matches() && n.on();
  },
  /**
   * removes the given handler from the collection, and calls it's destroy methods
   *
   * @param {object || function} handler the handler to remove
   */
  removeHandler: function(e) {
    var n = this.handlers;
    Ct(n, function(r, i) {
      if (r.equals(e))
        return r.destroy(), !n.splice(i, 1);
    });
  },
  /**
   * Determine whether the media query should be considered a match
   *
   * @return {Boolean} true if media query can be considered a match, false otherwise
   */
  matches: function() {
    return this.mql.matches || this.isUnconditional;
  },
  /**
   * Clears all handlers and unbinds events
   */
  clear: function() {
    Ct(this.handlers, function(e) {
      e.destroy();
    }), this.mql.removeListener(this.listener), this.handlers.length = 0;
  },
  /*
      * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
      */
  assess: function() {
    var e = this.matches() ? "on" : "off";
    Ct(this.handlers, function(n) {
      n[e]();
    });
  }
};
var Po = At, No = Po, Dt = Gr, Wo = Dt.each, ur = Dt.isFunction, Ho = Dt.isArray;
function $t() {
  if (typeof window < "u" && !window.matchMedia)
    throw new Error("matchMedia not present, legacy browsers require a polyfill");
  this.queries = {}, typeof window < "u" && (this.browserIsIncapable = !window.matchMedia("only all").matches);
}
$t.prototype = {
  constructor: $t,
  /**
   * Registers a handler for the given media query
   *
   * @param {string} q the media query
   * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
   * @param {function} options.match fired when query matched
   * @param {function} [options.unmatch] fired when a query is no longer matched
   * @param {function} [options.setup] fired when handler first triggered
   * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
   * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
   */
  register: function(e, n, r) {
    var i = this.queries, a = r && this.browserIsIncapable;
    return i[e] || (i[e] = new No(e, a)), ur(n) && (n = { match: n }), Ho(n) || (n = [n]), Wo(n, function(s) {
      ur(s) && (s = { match: s }), i[e].addHandler(s);
    }), this;
  },
  /**
   * unregisters a query and all it's handlers, or a specific handler for a query
   *
   * @param {string} q the media query to target
   * @param {object || function} [handler] specific handler to unregister
   */
  unregister: function(e, n) {
    var r = this.queries[e];
    return r && (n ? r.removeHandler(n) : (r.clear(), delete this.queries[e])), this;
  }
};
var zo = $t, Do = zo, Bo = new Do();
const Fo = /* @__PURE__ */ Xe(Bo);
var Ro = function(e) {
  return e.replace(/[A-Z]/g, function(n) {
    return "-" + n.toLowerCase();
  }).toLowerCase();
}, Vo = Ro, Xo = Vo, Uo = function(e) {
  var n = /[height|width]$/;
  return n.test(e);
}, sr = function(e) {
  var n = "", r = Object.keys(e);
  return r.forEach(function(i, a) {
    var s = e[i];
    i = Xo(i), Uo(i) && typeof s == "number" && (s = s + "px"), s === !0 ? n += i : s === !1 ? n += "not " + i : n += "(" + i + ": " + s + ")", a < r.length - 1 && (n += " and ");
  }), n;
}, Yo = function(e) {
  var n = "";
  return typeof e == "string" ? e : e instanceof Array ? (e.forEach(function(r, i) {
    n += sr(r), i < e.length - 1 && (n += ", ");
  }), n) : sr(e);
}, qo = Yo;
const cr = /* @__PURE__ */ Xe(qo), Ko = /* @__PURE__ */ st({
  __name: "VSlickArrow",
  props: _o,
  emits: [U.previous, U.next],
  setup(e, { emit: n }) {
    const r = e, i = n, a = Q(() => r.infinite ? !0 : r.type === U.previous ? r.currentSlideGroupIndex !== 0 && r.slideGroupCount > r.groupsToShow : (!r.centerMode || r.currentSlideGroupIndex < r.slideGroupCount - 1) && r.slideGroupCount > r.groupsToShow && r.currentSlideGroupIndex < r.slideGroupCount - r.groupsToShow), s = Q(() => () => {
      a.value && i(r.type);
    }), d = Q(() => ({
      currentSlideGroupIndex: r.currentSlideGroupIndex,
      slideGroupCount: r.slideGroupCount,
      onClick: s.value,
      disabled: !a.value
    }));
    return (g, C) => g.type === Lt(U).previous ? Oe(g.$slots, "prevArrow", De(Be({ key: 0 }, d.value)), () => [
      Fe("button", {
        type: "button",
        "data-role": "none",
        class: Me(["v-slick-arrow prev", { disabled: !a.value }]),
        onClick: C[0] || (C[0] = //@ts-ignore
        (...v) => s.value && s.value(...v))
      }, _t(g.prevArrowLabel), 3)
    ], !0) : Oe(g.$slots, "nextArrow", De(Be({ key: 1 }, d.value)), () => [
      Fe("button", {
        type: "button",
        "data-role": "none",
        class: Me(["v-slick-arrow next", { disabled: !a.value }]),
        onClick: C[1] || (C[1] = //@ts-ignore
        (...v) => s.value && s.value(...v))
      }, _t(g.nextArrowLabel), 3)
    ], !0);
  }
}), Bt = (e, n) => {
  const r = e.__vccOpts || e;
  for (const [i, a] of n)
    r[i] = a;
  return r;
}, dr = /* @__PURE__ */ Bt(Ko, [["__scopeId", "data-v-f402dd37"]]), Qo = ["onClick"], Zo = ["onClick"], Jo = ["onClick"], ei = /* @__PURE__ */ st({
  __name: "VSlickTrack",
  props: Lo,
  emits: ["childClick"],
  setup(e, { emit: n }) {
    const r = e, i = n, a = (v) => {
      let y = !1, h = !1, w = !1, b;
      return r.centerMode ? (b = Math.floor(r.groupsToShow / 2), h = (v - r.currentSlideGroupIndex) % r.slideGroupCount === 0, v > r.currentSlideGroupIndex - b - 1 && v <= r.currentSlideGroupIndex + b && (y = !0)) : y = r.currentSlideGroupIndex <= v && v < r.currentSlideGroupIndex + r.groupsToShow, w = v === r.currentSlideGroupIndex, Object.entries({
        active: y,
        center: h,
        current: w
      }).filter(([, G]) => G).map(([G]) => G);
    }, s = (v) => {
      let y = {};
      if ((r.variableWidth === void 0 || r.variableWidth === !1) && (y.width = typeof r.slideGroupWidth == "number" ? `${r.slideGroupWidth}px` : r.slideGroupWidth), r.fade) {
        if (y.position = "relative", r.vertical) {
          const h = r.slideGroupHeight ? typeof r.slideGroupHeight == "string" ? parseFloat(r.slideGroupHeight) : r.slideGroupHeight : 0;
          y.top = `${-v * h}px`;
        } else {
          const h = r.slideGroupWidth ? typeof r.slideGroupWidth == "string" ? parseFloat(r.slideGroupWidth) : r.slideGroupWidth : 0, w = r.rtl ? v * h : -v * h;
          y.left = `${w}px`;
        }
        y.opacity = r.currentSlideGroupIndex === v ? 1 : 0, y.transition = "opacity " + r.speed + "ms " + r.cssEase + ", visibility " + r.speed + "ms " + r.cssEase, r.ignorePrefersReducedMotion && (y.transition += " !important");
      }
      return y;
    }, d = Q(() => r.rawSlideGroups.map((y, h) => {
      const w = s(h), b = a(h), G = {
        slides: [],
        key: `original-${h}`,
        class: b,
        style: w,
        attrs: {
          "data-index": h,
          "aria-hidden": `${!b.includes("active")}`
        },
        onClick: () => {
          i("childClick", {
            index: r.rtl && r.infinite ? r.slideGroupCount + h : h
          });
        }
      };
      return (!r.lazyLoad || r.lazyLoad && r.lazyLoadedList.indexOf(h) >= 0) && (G.slides = y), G;
    })), g = Q(() => !r.infinite || r.fade || r.slideGroupCount <= r.groupsToShow ? [] : r.rawSlideGroups.map((y, h) => {
      const w = r.slideGroupCount - h;
      if (w > be(r)) return;
      const b = -w, G = {
        slides: [],
        key: `preclone-${b}`,
        class: a(b),
        style: s(h),
        attrs: {
          "data-index": b,
          "aria-hidden": "true"
        },
        onClick: () => {
          i("childClick", {
            index: b
          });
        }
      };
      return (b >= yr(r) || !r.lazyLoad || r.lazyLoad && r.lazyLoadedList.indexOf(h) >= 0) && (G.slides = y), G;
    }).filter((y) => y)), C = Q(() => !r.infinite || r.fade || r.slideGroupCount <= r.groupsToShow ? [] : r.rawSlideGroups.map((y, h) => {
      const w = r.slideGroupCount + h, b = {
        slides: [],
        key: `postclone-${w}`,
        class: a(w),
        style: s(h),
        attrs: {
          "data-index": w,
          "aria-hidden": "true"
        },
        onClick: () => {
          i("childClick", {
            index: r.rtl ? r.slideGroupCount + w : w
          });
        }
      };
      return (w < Sr(r) || !r.lazyLoad || r.lazyLoad && r.lazyLoadedList.indexOf(h) >= 0) && (b.slides = y), b;
    }));
    return (v, y) => (z(), K("div", {
      class: Me(["v-slick-track", { center: v.centerMode, vertical: v.vertical }]),
      style: hr(v.trackStyle)
    }, [
      (z(!0), K(me, null, we(g.value, (h, w) => (z(), K("div", Be({
        tabindex: "-1",
        key: h.key,
        class: [h.class, "v-slick-slide-group clone"],
        style: h.style,
        ref_for: !0
      }, h.attrs, {
        onClick: h.onClick
      }), [
        (z(!0), K(me, null, we(h.slides, (b, G) => (z(), Ee(Gt(b), {
          key: `slide-${w}-${G}` + (b.key ? `-${String(b.key)}` : "")
        }))), 128))
      ], 16, Qo))), 128)),
      (z(!0), K(me, null, we(d.value, (h, w) => (z(), K("div", Be({
        tabindex: "-1",
        key: h.key,
        class: ["v-slick-slide-group", h.class],
        style: h.style,
        ref_for: !0
      }, h.attrs, {
        onClick: h.onClick
      }), [
        (z(!0), K(me, null, we(h.slides, (b, G) => (z(), Ee(Gt(b), {
          key: `slide-${w}-${G}` + (b.key ? `-${String(b.key)}` : "")
        }))), 128))
      ], 16, Zo))), 128)),
      (z(!0), K(me, null, we(C.value, (h, w) => (z(), K("div", Be({
        tabindex: "-1",
        key: h.key,
        class: [h.class, "v-slick-slide-group clone"],
        style: h.style,
        ref_for: !0
      }, h.attrs, {
        onClick: h.onClick
      }), [
        (z(!0), K(me, null, we(h.slides, (b, G) => (z(), Ee(Gt(b), {
          key: `slide-${w}-${G}` + (b.key ? `-${String(b.key)}` : "")
        }))), 128))
      ], 16, Jo))), 128))
    ], 6));
  }
}), ti = /* @__PURE__ */ Bt(ei, [["__scopeId", "data-v-56b0fd31"]]), ri = ["onClick"], ni = /* @__PURE__ */ st({
  __name: "VSlickDots",
  props: Oo,
  emits: ["dotClick", "dotsOver", "dotsLeave"],
  setup(e) {
    const n = e, r = (i) => {
      const a = i * n.groupsToScroll, s = a + n.groupsToScroll - 1;
      return n.currentSlideGroupIndex >= a && n.currentSlideGroupIndex <= s;
    };
    return (i, a) => (z(), K("ul", {
      class: Me(i.dotsClass),
      style: { display: "block" },
      onMouseenter: a[0] || (a[0] = (s) => i.$emit("dotsLeave")),
      onMouseleave: a[1] || (a[1] = (s) => i.$emit("dotsLeave")),
      onMouseover: a[2] || (a[2] = (s) => i.$emit("dotsOver"))
    }, [
      (z(!0), K(me, null, we(i.pageCount, (s) => (z(), K("li", {
        key: s,
        class: Me({ active: r(s - 1) }),
        onClick: (d) => i.$emit("dotClick", {
          index: s - 1,
          groupsToScroll: i.groupsToScroll
        })
      }, [
        Oe(i.$slots, "customPaging", {
          page: s - 1
        }, () => [
          Fe("button", null, _t(s), 1)
        ])
      ], 10, ri))), 128))
    ], 34));
  }
});
var oi = "Expected a function", fr = NaN, ii = "[object Symbol]", li = /^\s+|\s+$/g, ai = /^[-+]0x[0-9a-f]+$/i, ui = /^0b[01]+$/i, si = /^0o[0-7]+$/i, ci = parseInt, di = typeof Z == "object" && Z && Z.Object === Object && Z, fi = typeof self == "object" && self && self.Object === Object && self, pi = di || fi || Function("return this")(), hi = Object.prototype, vi = hi.toString, gi = Math.max, yi = Math.min, It = function() {
  return pi.Date.now();
};
function Si(e, n, r) {
  var i, a, s, d, g, C, v = 0, y = !1, h = !1, w = !0;
  if (typeof e != "function")
    throw new TypeError(oi);
  n = pr(n) || 0, jt(r) && (y = !!r.leading, h = "maxWait" in r, s = h ? gi(pr(r.maxWait) || 0, n) : s, w = "trailing" in r ? !!r.trailing : w);
  function b(I) {
    var N = i, D = a;
    return i = a = void 0, v = I, d = e.apply(D, N), d;
  }
  function G(I) {
    return v = I, g = setTimeout(m, n), y ? b(I) : d;
  }
  function L(I) {
    var N = I - C, D = I - v, X = n - N;
    return h ? yi(X, s - D) : X;
  }
  function $(I) {
    var N = I - C, D = I - v;
    return C === void 0 || N >= n || N < 0 || h && D >= s;
  }
  function m() {
    var I = It();
    if ($(I))
      return M(I);
    g = setTimeout(m, L(I));
  }
  function M(I) {
    return g = void 0, w && i ? b(I) : (i = a = void 0, d);
  }
  function V() {
    g !== void 0 && clearTimeout(g), v = 0, i = C = a = g = void 0;
  }
  function B() {
    return g === void 0 ? d : M(It());
  }
  function W() {
    var I = It(), N = $(I);
    if (i = arguments, a = this, C = I, N) {
      if (g === void 0)
        return G(C);
      if (h)
        return g = setTimeout(m, n), b(C);
    }
    return g === void 0 && (g = setTimeout(m, n)), d;
  }
  return W.cancel = V, W.flush = B, W;
}
function jt(e) {
  var n = typeof e;
  return !!e && (n == "object" || n == "function");
}
function mi(e) {
  return !!e && typeof e == "object";
}
function wi(e) {
  return typeof e == "symbol" || mi(e) && vi.call(e) == ii;
}
function pr(e) {
  if (typeof e == "number")
    return e;
  if (wi(e))
    return fr;
  if (jt(e)) {
    var n = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = jt(n) ? n + "" : n;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(li, "");
  var r = ui.test(e);
  return r || si.test(e) ? ci(e.slice(2), r ? 2 : 8) : ai.test(e) ? fr : +e;
}
var bi = Si;
const Gi = /* @__PURE__ */ Xe(bi), Ti = { class: "v-slick-carousel" }, xi = ["dir"], ki = 50, Ci = /* @__PURE__ */ st({
  inheritAttrs: !1,
  __name: "VSlickCarousel",
  props: Ae,
  emits: [
    "init",
    "beforeChange",
    "afterChange",
    "lazyLoad",
    "lazyLoadError",
    "reInit",
    "edge",
    "swipe"
  ],
  setup(e, { expose: n, emit: r }) {
    var He, ze, nt;
    const i = e, a = r, s = kn(), d = Xn() ? Fo : void 0;
    let g, C = null, v = null, y = [];
    const h = Le({
      ...((nt = (ze = (He = Cn()) == null ? void 0 : He.vnode) == null ? void 0 : ze.props) == null ? void 0 : nt.style) || {}
    });
    let w = !0, b = null, G = null, L = [];
    const $ = (l, c) => {
      d && (d.register(l, c), L.push({ query: l, handler: c }));
    }, m = () => {
      L.forEach(
        ({ query: l, handler: c }) => d == null ? void 0 : d.unregister(l, c)
      ), L = [];
    }, M = () => {
      if (!i.responsive.length) return;
      const l = i.responsive.map((x) => x.breakpoint);
      l.sort((x, T) => x - T), l.forEach((x, T) => {
        const k = cr({
          minWidth: T === 0 ? 0 : l[T - 1] + 1,
          maxWidth: x
        });
        $(k, () => {
          pe.value = x;
        });
      });
      const c = cr({
        minWidth: l.slice(-1)[0]
      });
      $(c, () => {
        pe.value = void 0;
      });
    }, V = (l) => {
      const c = Wn(
        l,
        f.value.swipe,
        f.value.draggable
      );
      Object.assign(p.value, c);
    }, B = (l) => {
      var k;
      const c = Hn(l, {
        ...f.value,
        ...p.value,
        trackEl: (k = re.value) == null ? void 0 : k.$el,
        listEl: j.value,
        slideGroupIndex: p.value.currentSlideGroupIndex,
        slideGroupCount: P.value
      });
      if (!c) return;
      const { triggerSlideGroupHandler: x, ...T } = c;
      g = x, Object.assign(p.value, T), g !== void 0 && ae(g);
    }, W = (l) => {
      var x;
      Un();
      const c = Rn(l, {
        ...i,
        ...p.value,
        trackEl: (x = re.value) == null ? void 0 : x.$el,
        listEl: j.value,
        slideGroupIndex: p.value.currentSlideGroupIndex,
        slideGroupCount: P.value,
        onEdge: (T) => a("edge", T),
        swipeEvent: (T) => a("swipe", T)
      });
      c && (c.swiping && (w = !1), Object.assign(p.value, c));
    }, I = () => {
      let l;
      if (f.value.rtl)
        l = p.value.currentSlideGroupIndex - f.value.groupsToScroll;
      else if (Nt({ ...i, ...p.value }))
        l = p.value.currentSlideGroupIndex + f.value.groupsToScroll;
      else
        return !1;
      ae(l);
    }, N = (l = null) => {
      p.value.autoplayTimer && (clearInterval(p.value.autoplayTimer), p.value.autoplayTimer = null);
      const c = p.value.autoplaying;
      l === _.paused ? p.value.autoplaying = _.paused : l === _.focused && (c === _.hovered || c === _.playing) ? p.value.autoplaying = _.focused : c === _.playing ? p.value.autoplaying = _.hovered : c === null && (p.value.autoplaying = null);
    }, D = (l) => {
      p.value.autoplayTimer && clearInterval(p.value.autoplayTimer);
      const c = p.value.autoplaying;
      if (l === _.update) {
        if (c === _.hovered || c === _.focused || c === _.paused)
          return;
      } else if (l === _.leave) {
        if (c === _.paused || c === _.focused)
          return;
      } else if (l === _.blur && (c === _.paused || c === _.hovered))
        return;
      p.value.autoplayTimer = setInterval(
        I,
        f.value.autoplaySpeed + 50
      ), p.value.autoplaying = _.playing;
    }, X = () => {
      if (f.value.adaptiveHeight && j.value) {
        const l = j.value.querySelectorAll(
          ".v-slick-slide-group.active"
        );
        let c = 0;
        l.forEach((x) => {
          c = Math.max(c, x.offsetHeight);
        }), j.value.style.height = c + "px";
      }
    }, Ge = () => {
      f.value.autoplay && N(_.hovered);
    }, ee = () => {
      f.value.autoplay && p.value.autoplaying === _.hovered && D(_.leave);
    }, te = (l) => {
      w === !1 && (l.stopPropagation(), l.preventDefault()), w = !0;
    }, Ue = ({ index: l }) => {
      f.value.focusOnSelect && ce({
        message: "children",
        index: l
      });
    }, Ye = (l) => {
      if (!f.value.accessibility) return;
      const c = Mn(
        l,
        f.value.accessibility,
        f.value.rtl
      );
      c && ce({ message: c });
    }, $e = (l) => {
      if (!f.value.touchMove) return;
      const c = l.target;
      c != null && c.classList.contains("no-swipe") || V(l);
    }, qe = (l) => {
      if (!p.value.dragging || !f.value.touchMove) return;
      const c = l.target;
      c != null && c.classList.contains("no-swipe") || W(l);
    }, Ke = (l) => {
      f.value.touchMove && B(l);
    }, Qe = (l) => {
      !p.value.dragging || !f.value.touchMove || B(l);
    }, Ze = () => {
      f.value.pauseOnHover && Ge();
    }, A = () => {
      f.value.pauseOnHover && ee();
    }, dt = () => {
      f.value.pauseOnDotsHover && f.value.autoplay && N(_.hovered);
    }, ft = () => {
      f.value.pauseOnDotsHover && f.value.autoplay && p.value.autoplaying === _.hovered && D(_.leave);
    }, J = ({ index: l }) => {
      ce({
        message: "dots",
        index: l
      });
    }, Je = () => {
      ce({
        message: U.next
      });
    }, et = () => {
      ce({
        message: U.previous
      });
    }, ce = (l, c = !1) => {
      const x = {
        ...f.value,
        ...p.value,
        slideGroupCount: P.value
      }, T = An(
        x,
        l
      );
      T != null && ae(
        T,
        c === !0 ? !0 : void 0
      );
    }, ae = async (l, c = !1) => {
      var R, fe;
      const { asNavFor: x, speed: T } = f.value, k = p.value.currentSlideGroupIndex, { slidingState: O, afterSlidingState: H } = Fn({
        index: l,
        ...f.value,
        ...p.value,
        slideGroupCount: P.value,
        trackEl: (R = re.value) == null ? void 0 : R.$el,
        useCSSTransitions: f.value.useCSSTransitions && !c
      });
      if (!O) return;
      a(
        "beforeChange",
        k,
        O.currentSlideGroupIndex
      );
      const E = ((fe = O.lazyLoadedList) == null ? void 0 : fe.filter(
        (oe) => p.value.lazyLoadedList.indexOf(oe) < 0
      )) || [];
      E.length && a("lazyLoad", E), Object.assign(p.value, O), x && x.goTo(l), H && await new Promise((oe) => {
        C = setTimeout(() => {
          const { animating: ie, ...gt } = H;
          Object.assign(p.value, gt), y.push(
            setTimeout(() => {
              p.value.animating = ie || !1;
            })
          ), a("afterChange", O.currentSlideGroupIndex), C = null, oe();
        }, T);
      });
    }, je = (l) => {
      var O, H;
      const c = Vn({
        ...f.value,
        ...p.value,
        listEl: j.value,
        trackEl: (O = re.value) == null ? void 0 : O.$el,
        slides: ve.value
      }), x = {
        ...i,
        ...p,
        ...c,
        trackEl: (H = re.value) == null ? void 0 : H.$el,
        slideGroupCount: P.value
      }, T = Ve(x), k = Re(x, T);
      (l || P.value !== x.slideGroupCount) && (c.trackStyle = k), Object.assign(p.value, c);
    }, pt = (l = !0) => {
      !re.value || !re.value.$el || (je(l), i.autoplay ? D(_.update) : N());
    }, de = (l) => {
      b == null || b.cancel(), b = Gi(
        () => pt(l),
        ki
      ), b();
    }, Pe = () => de(), ht = () => {
      f.value.autoplay && N(_.focused);
    }, vt = () => {
      f.value.autoplay && p.value.autoplaying === _.focused && D(_.blur);
    }, tt = () => {
      const l = [], c = { ...f.value, ...p.value }, x = Et({
        ...c,
        slideGroupCount: P.value
      }), T = be({
        ...c,
        slideGroupCount: P.value
      });
      for (let k = p.value.currentSlideGroupIndex; k < P.value + x; k++)
        if (p.value.lazyLoadedList.indexOf(k) < 0) {
          l.push(k);
          break;
        }
      for (let k = p.value.currentSlideGroupIndex - 1; k >= -T; k--)
        if (p.value.lazyLoadedList.indexOf(k) < 0) {
          l.push(k);
          break;
        }
      l.length > 0 ? (p.value.lazyLoadedList = p.value.lazyLoadedList.concat(l), a("lazyLoad", l)) : v && (clearInterval(v), v = null);
    }, rt = () => {
      var T;
      const l = (T = j.value) == null ? void 0 : T.querySelectorAll(
        ".v-slick-slide-group img"
      ), c = (l == null ? void 0 : l.length) || 0;
      let x = 0;
      l == null || l.forEach((k) => {
        const O = () => {
          ++x >= c && de();
        };
        if (!k.onclick)
          k.onclick = () => {
            var H;
            (H = k.closest(".v-slick-slide-group")) == null || H.focus();
          };
        else {
          const H = k.onclick.bind(k);
          k.onclick = (E) => {
            var R;
            H(E), (R = k.closest(".v-slick-slide-group")) == null || R.focus();
          };
        }
        if (k.onload)
          k.onload = O, k.onerror = () => {
            O(), a("lazyLoadError");
          };
        else {
          if (!f.value.lazyLoad) return;
          k.onload = () => {
            X(), y.push(setTimeout(de, f.value.speed));
          };
        }
      });
    }, Ne = () => {
      const l = {
        ...f.value,
        ...p.value,
        slideGroupCount: P.value
      }, c = be(l), x = Et(l);
      if (f.value.variableWidth) {
        let T = [], k = [];
        const O = [];
        We.value.forEach((E) => {
          let R = 0;
          E.forEach((fe) => {
            var ie;
            const { width: oe } = ((ie = fe.props) == null ? void 0 : ie.style) || {};
            oe && (R = Math.max(R, oe));
          }), O.push(R), T.push(R);
        });
        for (let E = 0; E < c; E++)
          k.push(O[O.length - 1 - E]), T.push(O[O.length - 1 - E]);
        for (let E = 0; E < x; E++)
          T.push(O[E]);
        for (let E = 0; E < p.value.currentSlideGroupIndex; E++)
          k.push(O[E]);
        T = T.filter((E) => E), k = k.filter((E) => E);
        const H = {
          width: `calc(${T.join(" + ")})`,
          left: `calc(${k.map((E) => `-${E}`).join(" + ")})`
        };
        if (f.value.centerMode) {
          const E = O[p.value.currentSlideGroupIndex];
          H.left = `calc(${k.map((R) => `-${R}`).join(" + ")} + (100% - ${E}) / 2 )`;
        }
        p.value.trackStyle = H;
      } else {
        const T = c + x + P.value, k = 100 / f.value.groupsToShow * T, O = 100 / T;
        let H = -O * (c + p.value.currentSlideGroupIndex) * k / 100;
        f.value.centerMode && (H += (100 - O * k / 100) / 2), p.value.slideGroupWidth = O + "%", p.value.trackStyle = {
          width: k + "%",
          left: H + "%"
        };
      }
    }, pe = Le(), j = Le(), re = Le(), f = Q(() => {
      const l = or(i);
      let c = { ...Co, ...l };
      if (pe.value) {
        const x = i.responsive.find(
          (T) => T.breakpoint === pe.value
        );
        c = {
          ...c,
          ...x == null ? void 0 : x.settings
        };
      }
      return c.centerMode && (c.groupsToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `centerMode is enabled: groupsToScroll should be 1; you are using ${c.groupsToScroll}`
      ), c.groupsToScroll = 1), c.fade && (c.groupsToShow > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `fade is enabled: groupsToShow should be 1; you are using ${c.groupsToShow}`
      ), c.groupsToScroll > 1 && process.env.NODE_ENV !== "production" && console.warn(
        `fade is enabled: groupsToScroll should be 1; you are using ${c.groupsToScroll}`
      ), c.groupsToShow = 1, c.groupsToScroll = 1), c.slidesPerGroup > 1 && (c.variableWidth && process.env.NODE_ENV !== "production" && console.warn("slidesPerGroup is bigger than 1: variableWidth is disabled"), c.variableWidth = !1), c.vertical && c.rtl && (process.env.NODE_ENV !== "production" && console.warn("vertical mode is enabled: rtl is disabled"), c.rtl = !1), c;
    }), he = Q(() => {
      if (f.value.infinite)
        return Math.ceil(P.value / f.value.groupsToScroll);
      const l = Math.ceil(
        (P.value - i.groupsToShow) / f.value.groupsToScroll
      ) + 1;
      return l < 0 ? 0 : l;
    }), ve = Le(s.default ? Ot(s.default()) : []), p = Le({
      ...ct(Io),
      currentSlideGroupIndex: f.value.initialGroupIndex
    }), ne = Q(
      () => p.value.currentSlideGroupIndex
    ), Te = Q(() => f.value.groupsToShow), P = Q(
      () => wr(ve.value.length, f.value.slidesPerGroup)
    ), We = Q(() => {
      const l = [], c = f.value.slidesPerGroup, x = P.value;
      for (let T = 0; T < x; T++) {
        const k = T * c, O = k + c;
        l.push(ve.value.slice(k, O));
      }
      return l;
    });
    return _e(
      () => i,
      () => {
        m(), M();
      },
      { deep: !0 }
    ), _e(
      f,
      (l, c) => {
        let x = !1;
        for (const T of Object.keys(f.value)) {
          if (!l.hasOwnProperty(T)) {
            x = !0;
            break;
          }
          if (!(typeof l[T] == "object" || typeof l[T] == "function") && l[T] !== c[T]) {
            x = !0;
            break;
          }
        }
        je(x), p.value.currentSlideGroupIndex >= P.value && ce({
          message: "index",
          index: P.value - l.groupsToShow
        }), l.autoplay ? D(_.update) : N(_.paused);
      },
      {
        deep: !0
      }
    ), _e(
      () => {
        var l;
        return ((l = s.default) == null ? void 0 : l.call(s)) || [];
      },
      (l) => {
        ve.value = Ot(l);
      }
    ), _e(
      () => [
        p.value.listHeight,
        f.value.centerMode,
        f.value.centerPadding,
        f.value.vertical
      ],
      ([l, c, x, T]) => {
        let k = {
          height: "auto"
        };
        T && (k = {
          height: `${l}px`
        });
        let O;
        c ? T ? O = {
          padding: x + " 0px"
        } : O = {
          padding: "0px " + x
        } : O = {
          padding: "0"
        }, h.value = {
          ...h.value,
          ...or(k),
          ...O
        };
      }
    ), _e(
      () => [
        f.value.infinite,
        p.value.currentSlideGroupIndex,
        f.value.groupsToShow,
        P.value
      ],
      ([l, c, x, T]) => {
        l || c <= T - x + 1 || ae(he.value - 1);
      }
    ), _e(
      () => p.value.dragging,
      (l) => {
        j.value && (l ? (j.value.onmousemove = qe, j.value.ontouchmove = qe, j.value.onmouseup = Ke, j.value.ontouchend = Ke, j.value.onmouseleave = Qe, j.value.ontouchcancel = Qe) : (j.value.onmousemove = null, j.value.ontouchmove = null, j.value.onmouseup = null, j.value.ontouchend = null, j.value.onmouseleave = null, j.value.ontouchcancel = null));
      }
    ), n({
      goTo: ae,
      next: () => {
        ae(
          p.value.currentSlideGroupIndex + f.value.groupsToScroll
        );
      },
      prev: () => {
        ae(
          p.value.currentSlideGroupIndex - f.value.groupsToScroll
        );
      },
      play: I,
      pause: N,
      autoPlay: D,
      slideGroupCount: P,
      currentSlideGroupIndex: ne,
      currentGroupsToShow: Te,
      pageCount: he
    }), In(() => {
      var l;
      window.addEventListener("resize", Pe), je(!0), X(), f.value.autoplay && D(_.update), f.value.lazyLoad === vr.progressive && (v = setInterval(tt, 1e3)), G = new ResizeObserver(() => {
        p.value.animating ? (de(!1), y.push(
          setTimeout(() => de(), f.value.speed)
        )) : de();
      }), G.observe(j.value), (l = j.value) == null || l.querySelectorAll(".v-slick-slide-group").forEach((c) => {
        c.onfocus = f.value.pauseOnFocus ? ht : null, c.onblur = f.value.pauseOnFocus ? vt : null;
      });
    }), Ln(() => {
      if (rt(), a("reInit"), f.value.lazyLoad) {
        const l = Pt({
          ...f.value,
          ...p.value
        });
        l.length && (p.value.lazyLoadedList = p.value.lazyLoadedList.concat(l), a("lazyLoad", l));
      }
      X();
    }), _n(() => {
      window.removeEventListener("resize", Pe), G == null || G.unobserve(j.value), C && clearTimeout(C), v && clearInterval(v), y.length && (y.forEach((l) => clearTimeout(l)), y = []), p.value.autoplayTimer && clearInterval(p.value.autoplayTimer);
    }), M(), Ne(), a("init"), (l, c) => (z(), K("div", Ti, [
      Fe("div", {
        class: "v-slick-slider",
        dir: f.value.rtl ? "rtl" : "ltr"
      }, [
        f.value.arrows ? (z(), Ee(dr, {
          key: 0,
          type: Lt(U).previous,
          "center-mode": f.value.centerMode,
          infinite: f.value.infinite,
          "groups-to-show": f.value.groupsToShow,
          "slide-group-count": P.value,
          "current-slide-group-index": p.value.currentSlideGroupIndex,
          onPrevious: et
        }, {
          prevArrow: Tt((x) => [
            Oe(l.$slots, "prevArrow", De(xt(x)), void 0, !0)
          ]),
          _: 3
        }, 8, ["type", "center-mode", "infinite", "groups-to-show", "slide-group-count", "current-slide-group-index"])) : kt("", !0),
        Fe("div", {
          ref_key: "vSlickListRef",
          ref: j,
          class: Me(["v-slick-list", { dragging: p.value.dragging }]),
          style: hr(h.value),
          onClick: te,
          onMousedown: $e,
          onTouchstartPassive: $e,
          onKeydown: Ye
        }, [
          On(ti, {
            ref_key: "vSlickTrackRef",
            ref: re,
            "center-mode": f.value.centerMode,
            "center-padding": f.value.centerPadding,
            "raw-slide-groups": We.value,
            "css-ease": l.cssEase,
            "current-slide-group-index": p.value.currentSlideGroupIndex,
            fade: f.value.fade,
            "ignore-prefers-reduced-motion": f.value.ignorePrefersReducedMotion,
            infinite: f.value.infinite,
            "lazy-load": f.value.lazyLoad,
            "lazy-loaded-list": p.value.lazyLoadedList,
            "list-height": p.value.listHeight,
            rtl: f.value.rtl,
            "slide-group-count": P.value,
            "slide-group-height": p.value.slideGroupHeight,
            "slide-group-width": p.value.slideGroupWidth,
            "groups-to-scroll": f.value.groupsToScroll,
            "groups-to-show": f.value.groupsToShow,
            speed: f.value.speed,
            "track-style": p.value.trackStyle,
            "variable-width": f.value.variableWidth,
            vertical: f.value.vertical,
            onMouseenter: Ze,
            onMouseleave: A,
            onMouseover: Ze,
            onChildClick: Ue
          }, null, 8, ["center-mode", "center-padding", "raw-slide-groups", "css-ease", "current-slide-group-index", "fade", "ignore-prefers-reduced-motion", "infinite", "lazy-load", "lazy-loaded-list", "list-height", "rtl", "slide-group-count", "slide-group-height", "slide-group-width", "groups-to-scroll", "groups-to-show", "speed", "track-style", "variable-width", "vertical"])
        ], 38),
        f.value.arrows ? (z(), Ee(dr, {
          key: 1,
          type: Lt(U).next,
          "center-mode": f.value.centerMode,
          infinite: f.value.infinite,
          "groups-to-show": f.value.groupsToShow,
          "slide-group-count": P.value,
          "current-slide-group-index": p.value.currentSlideGroupIndex,
          onNext: Je
        }, {
          nextArrow: Tt((x) => [
            Oe(l.$slots, "nextArrow", De(xt(x)), void 0, !0)
          ]),
          _: 3
        }, 8, ["type", "center-mode", "infinite", "groups-to-show", "slide-group-count", "current-slide-group-index"])) : kt("", !0)
      ], 8, xi),
      f.value.dots ? (z(), Ee(ni, {
        key: 0,
        "current-slide-group-index": p.value.currentSlideGroupIndex,
        infinite: f.value.infinite,
        "slide-group-count": P.value,
        "groups-to-scroll": f.value.groupsToScroll,
        "groups-to-show": f.value.groupsToShow,
        "dots-class": f.value.dotsClass,
        "page-count": he.value,
        onDotClick: J,
        onDotsOver: dt,
        onDotsLeave: ft
      }, {
        customPaging: Tt((x) => [
          Oe(l.$slots, "customPaging", De(xt(x)), void 0, !0)
        ]),
        _: 3
      }, 8, ["current-slide-group-index", "infinite", "slide-group-count", "groups-to-scroll", "groups-to-show", "dots-class", "page-count"])) : kt("", !0)
    ]));
  }
}), Li = /* @__PURE__ */ Bt(Ci, [["__scopeId", "data-v-dcb7a03e"]]);
export {
  vr as LazyLoadType,
  _ as PlayingType,
  U as SlideNavigation,
  le as SwipeDirection,
  Li as VSlickCarousel
};
//# sourceMappingURL=index.es.mjs.map
